<div class="top-row">
    <div class="image">
        <img [src]="card.icon" [class]="card.iconClass || 'icon-white'">
    </div>
    <div class="module-title">{{ card.name }}</div>
</div>
<div class="description">
    {{ card.description }}
</div>
